export default __webpack_public_path__ + "media/images/icons_fc/mobile-phone-f354cfe375808a8b32db586c2c4b7157.png";